import { defineChain } from 'viem'

/** GateLayer mainnet の viem 接続定義。 */
export const gateLayer = defineChain({
  id: 10088,
  name: 'GateLayer',
  nativeCurrency: { name: 'GateToken', symbol: 'GT', decimals: 18 },
  rpcUrls: { default: { http: ['https://gatelayer-mainnet.gatenode.cc'] } },
  blockExplorers: {
    default: {
      name: 'GateScan',
      url: 'https://www.gatescan.org/gatelayer',
      apiUrl: 'https://www.gatescan.org/gatelayer/api',
    },
  },
  testnet: false,
})
